
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const appendClass = computed(() => {
      const append: string[] = []
      if (props.loading) {
        append.push('content__now-loading')
      }
      return append
    })

    return {
      appendClass
    }
  }
})
